import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { getBannerShopZoneInfo } from 'yoda-interfaces/lib/FindStorePageIRIS/IrisBannerShopZoneApi';
import irisBannerShopZoneActionTypes from '../actionTypes/IrisBannerShopZoneActionTypes';

function* irisBannerShoppableZoneSaga() {
    try {
        const response = yield call(getBannerShopZoneInfo) || {};
        const bannerShopZoneInfo = get(response.data, 'content.components', []);
        if (bannerShopZoneInfo.length) {
            yield put({
                type: irisBannerShopZoneActionTypes.IRIS_BANNER_SHOPZONE_SUCCESS,
                bannerShopZoneInfo,
            });
        } else {
            yield put({ type: 'IRIS_BANNER_SHOPZONE_ERROR' });
        }
    } catch (error) {
        yield put({ type: 'IRIS_BANNER_SHOPZONE_ERROR', error });
    }
}

function* watchIrisBannerShopZoneRequest() {
    yield takeLatest(
        irisBannerShopZoneActionTypes.IRIS_BANNER_SHOPZONE_REQUEST,
        irisBannerShoppableZoneSaga
    );
}

watchIrisBannerShopZoneRequest.sagaName = 'irisBannerShoppableZoneSaga';
export default watchIrisBannerShopZoneRequest;
